var React = require('react');

function CtaArrowDiagonalUpRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.17059 11.3301L11.8309 3.66982M11.8309 3.66982L5.3491 3.66982M11.8309 3.66982L11.8309 10.1516","stroke":"#F3F1ED","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

CtaArrowDiagonalUpRight.defaultProps = {"width":"16","height":"15","viewBox":"0 0 16 15","fill":"none"};

module.exports = CtaArrowDiagonalUpRight;

CtaArrowDiagonalUpRight.default = CtaArrowDiagonalUpRight;
